export default "<section id=\"main-user\">\n  <div class=\"container user-logo-tc-block\"></div>\n</section>"